export default "__VITE_ASSET__SEwOLzzf__"